import styled from "styled-components";
import { PRIMARY_LIGHT } from "../../constants/colors";
import { LEFT_MENU_WIDTH } from "../../constants/constants";
import { MainMenu } from "../../constants/options";
import { RenderNavMenu } from "../../utils/menuUtils";

export const LeftMenu = () => {
  return (
    <Wrapper className="whiteBg y100 scroll">
      <div className="p10 flexColumn gap10">
        <RenderNavMenu menu={MainMenu()} />
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  overflow-y: auto;
  ::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;

  height: calc(100% - 56px);
  border-right: 1px solid ${PRIMARY_LIGHT};
  width: ${LEFT_MENU_WIDTH};
  position: fixed;
  @media (max-width: 960px) {
    display: none;
  }
`;
